import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { InputObservable, connectState } from '@y42/angular/util';
import { DateTimeFormat } from '@y42/date-time';
import { Y42RouterService } from '@y42/feature/routing';
import { importIcon } from '@y42/icons';
import { Observable, map, switchMap } from 'rxjs';
import { JobQuery } from '../../../state';
import { JobInfoService } from '../job-info.service';

@UntilDestroy()
@Component({
  selector: 'y42-job-info-content[jobId]',
  templateUrl: './job-info-content.component.html',
  styleUrls: ['./job-info-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobInfoContentComponent {
  constructor(
    private readonly jobQuery: JobQuery,
    private readonly jobInfoService: JobInfoService,
    private readonly y42RouterService: Y42RouterService,
  ) {}
  @Input()
  @InputObservable()
  jobId!: string;
  private readonly jobId$!: Observable<string>;

  @Input()
  showLogsButton = false;

  @Output()
  readonly showRequest = new EventEmitter();

  @Output()
  readonly showLogs = new EventEmitter();

  readonly importIcon = importIcon;
  readonly DateTimeFormat = DateTimeFormat;

  readonly state = connectState(this, {
    model: this.jobId$.pipe(
      switchMap((jobId) => this.jobQuery.selectUIEntity(jobId)),
      map((job) => (job ? this.jobInfoService.toJobInfoUIModel(job) : undefined)),
    ),
  });

  navigateToDatasource(event: Event, url: string) {
    event.stopPropagation();
    event.preventDefault();
    return this.y42RouterService.navigateByUrl(url);
  }
}
